<div [id]="backgroundImageId" class="bg-image shadow" color="primary">
  <div class="mask d-flex h-100">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-xl-7 col-md-8">
          <form class="bg-white rounded shadow-5-strong px-4 py-1 mt-3" [formGroup]="signUpForm">
            <div class="d-flex justify-content-center" >
              <div class="col-md-8 col-sm-12 d-flex justify-content-center">
                <img [src]="logoUrl" alt="IEA logo" class="logo" />
              </div>
            </div>
            <div class="col-12 text-center">
              <h2 class="p-0 m-0">Sign Up</h2>
              <p class="p-0 m-0">It takes just a few steps to create your account.</p>
              <!-- <hr /> -->
            </div>
            <div class="example-container mt-3">
              <div class="row">
                <div class="col-12 col-md-6 my-0 py-0">
                  <eq-textInput
                    [label]="'First Name'"
                    [icon]="'person'"
                    [form]="signUpForm"
                    [name]="'firstName'"
                    [validators]="firstNameValidators"
                    class=" my-0 py-0"
                  ></eq-textInput>
                </div>
                <div class="col-12 col-md-6 my-0 py-0">
                  <eq-textInput
                    [label]="'Last Name'"
                    [icon]="'person'"
                    [form]="signUpForm"
                    [name]="'lastName'"
                    [validators]="lastNameValidators"
                    class=" my-0 py-0"
                  ></eq-textInput>
                </div>
                <div class="col-12 col-md-6 my-0 py-0">
                  <eq-email
                    [form]="signUpForm"
                    [name]="'email'"
                    [label]="'Email Address'"
                    [validators]="emailValidators"
                    (onChange)="onFieldChange('email', $event)"
                    (onBlur)="onEmailBlur($event)"
                    (navigateToResetPassword)="navigateToResetPassword()"
                    class=" my-0 py-0"
                  ></eq-email>
                </div>
                <div class="col-12 col-md-6 my-0 py-0">
                  <eq-email
                    [form]="signUpForm"
                    [name]="'confirmEmail'"
                    [label]="'Confirm Email Address'"
                    [validators]="confirmEmailValidators"
                    (onChange)="onFieldChange('confirmEmail', $event)"
                    class=" my-0 py-0"
                  ></eq-email>
                </div>
                <div class="col-12 col-md-6">
                  <eq-password
                    [label]="'Password'"
                    [form]="signUpForm"
                    [name]="'password'"
                    [validators]="passwordValidators"
                    (onChange)="onFieldChange('password', $event)"
                    class=""
                  ></eq-password>
                </div>
                <div class="col-12 col-md-6">
                  <eq-password
                    [label]="'Confirm Password'"
                    [form]="signUpForm"
                    [name]="'confirmPassword'"
                    [validators]="confirmPasswordValidators"
                    (onChange)="onFieldChange('confirmPassword', $event)"
                    class=""
                  ></eq-password>
                </div>
                <div class="col-12 col-md-6">
                  <eq-phone-number
                    [label]="'Phone Number'"
                    [icon]="'call'"
                    [form]="signUpForm"
                    [name]="'phoneNumber'"
                    [validators]="phoneNumberValidators"
                    (onBlur)="onPhoneNumberBlur($event)"
                    class=""
                  ></eq-phone-number>
                  <span
                  *ngIf="appName == 'arenaEqApp'" 
                  class="help-icon" 
                  >
                    <mat-icon class="material-symbols-outlined">help</mat-icon>
                    <small >
                      Why does ArenaEQ ask for my phone #? This is to send text messages to notify you of any important updates.
                    </small>
                  </span>
                </div>
                <div class="col-12 col-md-6">
                  <eq-datePicker
                    [label]="'Date of Birth'"
                    [form]="signUpForm"
                    [name]="'dob'"
                    [validators]="dobValidators"
                    (onChange)="onFieldChange('dob', $event)"
                    class=""
                  ></eq-datePicker>
                </div>
              </div>
            </div>
            <div class="mb-3" style="margin-top: -30px;">
              <eq-ar-communication-pref
              *ngIf="appName == 'arenaEqApp'"
              (changeCommunicationPrefHandler)="changeCommunicationPrefHandler($event)"
              ></eq-ar-communication-pref>
            </div>
            <div class="row mb-2">
              <div class="col-12 d-flex justify-content-start">
                <div class="form-check">
                  <eq-checkbox
                    [name]="'isAccepted'"
                    [form]="signUpForm"
                    [validators]="agreeValidators"
                    (onChange)="onFieldChange('isAccepted', $event)"
                    class="m-0 p-0"
                  >
                    <label class="form-check-label m-0 p-0" for="form1Example3">
                      <i>
                        By creating an account, I agree to
                        <span class="text-primary" color="primary" (click)="goToTermsAndCondition()">{{appName == 'ieaApp' ? 'IEA’s' : 'ArenaEQ’s'}} Terms</span> of Use &
                        <span class="text-primary" color="primary" (click)="goToPrivacyPolicy()">Privacy Policy</span
                        >.
                      </i>
                    </label>
                  </eq-checkbox>
                </div>
              </div>
            </div>

            <!-- Submit button -->
            <button
              mat-button
              mat-raised-button
              color="primary"
              type="submit"
              (click)="signUp(signUpForm)"
              class="btn btn-primary btn-block w-100 py-3"
              [disabled]="!this.signUpForm.valid || loading"
            >SIGN UP</button>

            <div class="col-12">
              <div class="row justify-content-center my-2">
                <div class="col-4">
                  <hr/>
                </div>
                <div class="col-4">
                  <p class="text-center p-0">Already have an account?</p>
                </div>
                <div class="col-4">
                  <hr/>
                </div>
              </div>
              <button
                type="button"
                class="btn btn-Sign-in btn-block w-100 py-3"
                (click)="navigateTologinPage()"
              >
                SIGN IN
              </button>
            </div>
            <div class="col-12 text-center mt-2">
              <img
                class="footer-logo"
                src="../../../assets/images/poweredby-OneEquineblack-logo.png"
                alt="IEA logo"
              />
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
